import * as React from "react";

// import ReportStatusGroup from './report-status-group';
import CreationDateGroup from './creation-date-group';

import "./styles.css";
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

class ReportSidebarFilters extends React.Component<{}> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
        <div>
            <div className="sidebar-title">
            <FormattedMessage
                    id="sidebar-filters.heading"
                    defaultMessage={`Filter`}
                  />
            </div>
            {/* <ReportStatusGroup title="Report status" /> */}
            <CreationDateGroup />
        </div>
    );
  }
}

export default connect()(ReportSidebarFilters);



// WEBPACK FOOTER //
// ./src/components/report-sidebar-filters/index.tsx